module.exports = __webpack_public_path__ + "static/media/DancingDoodle.7c70f56e.png";